export const COLOR_SECTIONS = {
  geral: {
    label: "Geral",
    bootstrap: { cols: 2 },
    flat: [
      { key: "themePrimary", label: "Primária" },
      { key: "themeSecondary", label: "Secundária" },
      { key: "themeTertiary", label: "Terciária" },
      { key: "themeSupport", label: "Suporte" },
      { key: "bgPrimary", label: "Fundo Principal" },
      { key: "bgSecondary", label: "Fundo Secundário" },
      { key: "bgTertiary", label: "Fundo Terciário" },
      { key: "bgCard", label: "Fundo Card" },
      { key: "bgContent", label: "Fundo Conteúdo" },
      { key: "bgScrollBar", label: "ScrollBar" },
    ],
    text: [
      { key: "textPrimary", label: "Texto Principal" },
      { key: "textSecondary", label: "Texto Secundário" },
      { key: "textMuted", label: "Texto Muted" },
      { key: "textInverse", label: "Texto Inverso" },
    ],
    border: [
      { key: "borderPrimary", label: "Borda Principal" },
      { key: "borderSecondary", label: "Borda Secundária" },
      { key: "borderFocus", label: "Borda Foco" },
    ],
    status: [
      { key: "statusSuccess", label: "Sucesso" },
      { key: "statusWarning", label: "Aviso" },
      { key: "statusDanger", label: "Perigo" },
      { key: "statusInfo", label: "Info" },
    ],
  },
  menu: {
    label: "Menu",
    bootstrap: { cols: 2 },
    nested: true,
    key: "menu",
    fields: [
      { key: "bgMain", label: "Fundo Principal" },
      { key: "bgEnabled", label: "Item Ativo" },
      { key: "textDisabled", label: "Texto Desabilitado" },
      { key: "textEnabled", label: "Texto Habilitado" },
      { key: "textHover", label: "Texto Hover" },
    ],
  },
  cards: {
    label: "Cards",
    bootstrap: { cols: 2 },
    nested: true,
    key: "cards",
    fields: [
      { key: "background", label: "Fundo" },
      { key: "subtitle", label: "Subtítulo" },
      { key: "value", label: "Valor" },
    ],
  },
  filters: {
    label: "Filtros",
    bootstrap: { cols: 2 },
    nested: true,
    key: "filters",
    fields: [
      { key: "background", label: "Fundo" },
      { key: "title", label: "Título" },
      { key: "subtitle", label: "Subtítulo" },
      { key: "border", label: "Borda" },
    ],
  },
  tables: {
    label: "Tabelas",
    bootstrap: { cols: 2 },
    nested: true,
    key: "tables",
    fields: [
      { key: "headerBg", label: "Header Fundo" },
      { key: "text", label: "Texto" },
      { key: "rowBg", label: "Linha Par" },
      { key: "rowBgAlt", label: "Linha Ímpar" },
      { key: "paginationText", label: "Paginação Texto" },
      { key: "paginationHover", label: "Paginação Hover" },
    ],
  },
  buttons: {
    label: "Botões",
    bootstrap: { cols: 2 },
    nested: true,
    key: "buttons",
    fields: [
      { key: "bgBtnPrimary", label: "Fundo Primário" },
      { key: "bgBtnSecondary", label: "Fundo Secundário" },
      { key: "bgBtnTertiary", label: "Fundo Terciário" },
      { key: "btnSuccess", label: "Botão Sucesso" },
      { key: "textPrimary", label: "Texto Primário" },
      { key: "textSecondary", label: "Texto Secundário" },
      { key: "textHoverPrimary", label: "Hover Primário" },
      { key: "textHoverSecondary", label: "Hover Secundário" },
    ],
  },
};